/*---------------------------
| Get Default Context State
---------------------------*/
export const getDefaultState = ({
    assetType = "photo",
    asset = {},
    assetDownloadConfig
}) => {
    const {
        getDefaultPurchaseTypeByAsset,
        atrributionRequiredCheck
    } = assetDownloadConfig;

    const purchaseType = getDefaultPurchaseTypeByAsset(asset);

    return {
        assetType: assetType,
        asset: asset,
        isReadyForDownload: false,
        attribution: {
            isRequired: atrributionRequiredCheck(purchaseType),
            isVisible: false,
            isCopied: false
        },
        showPurchaseTypeDrawer: false,
        showSpeechBubble: false, //when set to true, will trigger animated show speech bubble, and then returns to false.
        purchaseType: purchaseType,
        assetDownloadConfig: assetDownloadConfig
    };
};
